<template>
	<section id="agent-map-section" class="section no-padding-top">
		<div class="container">
			<div class="filter-map" :class="pagedItems && pagedItems.length > 0 ? 'has-records' : 'no-records'">
				<!-- <div :class="pagedItems && pagedItems.length > 0 ? 'has-records' : ''"></div> -->
				<!-- :class="sportTypes.sports.indexOf(sport) > -1 ? 'is-primary' : 'is-outlined'"

	<agent-map v-if="pagedItems && pagedItems.length > 0"></agent-map> -->

				<span class="sr-only">Making a selection with these options will cause content on this page to change. Agent filter and listings will update as each option is entered.</span>
				<div class="filter-tabs-nav" role="tablist" v-on:keyup="tabSelect">
					<div class="filter-tabs-nav-btns">
						<button id="location-button" v-on:click="setTab('location')" type="button" class="filter-tabs-label" v-bind:class="{ active: tab === 'location' }" role="tab" aria-controls="filter-tabpanel" :aria-selected="(tab === 'location') ? 'true': 'false'" :tabindex="(tab === 'location') ? '0': '-1'">Search by zip code</button>
						<button id="name-button" v-on:click="setTab('name')" type="button" class="filter-tabs-label" v-bind:class="{ active: tab === 'name' }" role="tab" aria-controls="filter-tabpanel" :aria-selected="(tab === 'name') ? 'true': 'false'" :tabindex="(tab === 'name') ? '0': '-1'">Search by name</button>
					</div>
				</div>
				<div id="filter-tabpanel" role="tabpanel" tabindex="0" :aria-labelledby="(tab === 'location') ? 'location-button': 'name-button'">
					<div v-if="filters" class="filter-tabs">
						<div v-if="tab === 'location'" class="filter-tabs-inputs">
							<textbox-control v-bind:key="'Zipcode'" autocomplete="postal-code" v-bind:control="filters.Zipcode.subgroup" v-bind:parent="filters.Zipcode" v-bind:class="filters.Zipcode.className"></textbox-control>
							<div class="control">
								<button v-on:click="toggleFilter" type="button" id="filter-tab" class="btn btn--primary filter-btn">
									<span class="filter-icon" aria-hidden="true">
										<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true">
											<g id="Agent-/-Advisor-Search" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g id="FSFB---Agent-Advisor-Search---XL" transform="translate(-556.000000, -494.000000)">
													<g id="Group-6" transform="translate(524.000000, 480.000000)">
														<g id="icon-filter" transform="translate(32.000000, 14.000000)">
															<rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
															<path d="M12,16.2 C13.37739,16.2 14.5482975,17.0840538 14.9762617,18.3157006 L15.0275479,18.3070644 L15.0275479,18.3070644 L15.15,18.3 L21.45,18.3 C22.0298992,18.3 22.5,18.7701007 22.5,19.35 C22.5,19.8884778 22.094658,20.3322824 21.5724521,20.3929356 L21.45,20.4 L15.15,20.4 C15.0906172,20.4 15.0323853,20.3950703 14.9756926,20.3855982 C14.5482975,21.6159462 13.37739,22.5 12,22.5 C10.62261,22.5 9.4517025,21.6159462 9.02373825,20.3842994 L8.97245205,20.3929356 L8.97245205,20.3929356 L8.85,20.4 L2.55,20.4 C1.97010075,20.4 1.5,19.9298993 1.5,19.35 C1.5,18.8115222 1.905342,18.3677176 2.42754795,18.3070644 L2.55,18.3 L8.85,18.3 C8.90938275,18.3 8.9676147,18.3049297 9.02430735,18.3144018 C9.4517025,17.0840538 10.62261,16.2 12,16.2 Z M12,18.3 C11.4201008,18.3 10.95,18.7701007 10.95,19.35 C10.95,19.9298993 11.4201008,20.4 12,20.4 C12.5798992,20.4 13.05,19.9298993 13.05,19.35 C13.05,18.7701007 12.5798992,18.3 12,18.3 Z M4.65,8.85 C6.02739,8.85 7.1982975,9.7340538 7.62626175,10.9657006 L7.67754795,10.9570644 L7.67754795,10.9570644 L7.8,10.95 L21.45,10.95 C22.0298992,10.95 22.5,11.4201007 22.5,12 C22.5,12.5384778 22.094658,12.9822824 21.5724521,13.0429356 L21.45,13.05 L7.8,13.05 C7.74061725,13.05 7.6823853,13.0450703 7.62569265,13.0355982 C7.1982975,14.2659462 6.02739,15.15 4.65,15.15 C2.9103033,15.15 1.5,13.7396967 1.5,12 C1.5,10.2603033 2.9103033,8.85 4.65,8.85 Z M4.65,10.95 C4.07010075,10.95 3.6,11.4201007 3.6,12 C3.6,12.5798993 4.07010075,13.05 4.65,13.05 C5.22989925,13.05 5.7,12.5798993 5.7,12 C5.7,11.4201007 5.22989925,10.95 4.65,10.95 Z M16.2,1.5 C17.57739,1.5 18.7482975,2.3840538 19.1762617,3.61570065 L19.2275479,3.6070644 L19.2275479,3.6070644 L19.35,3.6 L21.45,3.6 C22.0298992,3.6 22.5,4.07010075 22.5,4.65 C22.5,5.1884778 22.094658,5.63228235 21.5724521,5.6929356 L21.45,5.7 L19.35,5.7 C19.2906172,5.7 19.2323853,5.69507025 19.1756926,5.6855982 C18.7482975,6.9159462 17.57739,7.8 16.2,7.8 C14.82261,7.8 13.6517025,6.9159462 13.2237383,5.68429935 L13.1724521,5.6929356 L13.1724521,5.6929356 L13.05,5.7 L2.55,5.7 C1.97010075,5.7 1.5,5.22989925 1.5,4.65 C1.5,4.1115222 1.905342,3.66771765 2.42754795,3.6070644 L2.55,3.6 L13.05,3.6 C13.1093828,3.6 13.1676147,3.60492975 13.2243074,3.6144018 C13.6517025,2.3840538 14.82261,1.5 16.2,1.5 Z M16.2,3.6 C15.6201008,3.6 15.15,4.07010075 15.15,4.65 C15.15,5.22989925 15.6201008,5.7 16.2,5.7 C16.7798992,5.7 17.25,5.22989925 17.25,4.65 C17.25,4.07010075 16.7798992,3.6 16.2,3.6 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
									Filter
								</button>
								<div v-if="filterOpen" id="filter-dropdown" class="filter-dropdown">
									<button v-on:click="toggleFilter" type="button" title="Clear" class="icon-icon-Close"></button>
									<div class="form-group">
										<label for="agentType">Service</label>
										<select id="agentType" class="form-control" @change="clearSelect('agentType')" v-model="agentType">
											<option v-bind:value="''">{{ filters.AgentType.defaultValue }}</option>
											<option v-for="value in filters.AgentType.subgroup" v-bind:value="value.Value">{{ value.Name }}</option>
										</select>
									</div>
									<div class="form-group">
										<label for="maxMiles">Distance</label>
										<select id="maxMiles" class="form-control" @change="clearSelect('maxMiles')" v-model="maxMiles">
											<option v-for="value in filters.MaxMiles.subgroup" v-bind:value="value.Value">{{ value.Name }}</option>
										</select>
									</div>
									<button v-on:click="applyFilters" type="button" class="btn btn--primary">Apply</button>
								</div>
							</div>
						</div>
						<div v-if="tab === 'name'" class="filter-tabs-inputs" tabindex="0">
							<label class="sr-only" for="Sort-By-filter">States</label>
							<select-control v-bind:key="'StateCode'" v-bind:control="filters.StateCode.subgroup" v-bind:defaultValue="filters.StateCode.defaultValue" v-bind:specification="'StateCode'"></select-control>
							<textbox-control v-bind:key="'Name'" v-bind:control="filters.Name.subgroup" v-bind:parent="filters.Name" v-bind:class="filters.Name.className" autocomplete="name"></textbox-control>
						</div>
					</div>
					<div class="filter-map-results">
						<ul class="filter-has-results" v-if="pagedItems && pagedItems.length > 0">
							<agent-card v-for="(item, index) in pagedItems" v-bind:item="item" v-bind:index="index" v-bind:key="item.Email"></agent-card>
						</ul>
						<pagination v-bind:totalResults="listing.length"></pagination>

						<div class="filter-no-results" v-if="!pagedItems || pagedItems.length === 0">
							<fragment v-if="tab === 'location'">
								<div class="bg-quaternary" v-if="specification.AgentType !== null || specification.MaxMiles !== null" id="location-tab">
									<h2>Sorry, we couldn’t find anyone matching your specifications</h2>
									<p>
										<span v-if="specification.Zipcode !== null"><b>Zip code:</b> {{ specification.Zipcode }}<br /></span>
										<span v-if="specification.MaxMiles !== null"><b>Distance:</b> Under {{ specification.MaxMiles }} miles<br /></span>
										<span v-if="specification.AgentType !== null"><b>Service:</b> {{ agentTypeDisplayName }}<br /></span>
									</p>
									<p>Try <u v-on:click="toggleFilter" class="link-text">adjusting some filters</u> or increasing the search distance.</p>
								</div>
								<div class="bg-quaternary" v-else id="location-tab">
									<h2>Looks like you're outside of our business area.</h2>
									<p v-if="specification.Zipcode !== null"><span><b>Zip code:</b></span> {{ specification.Zipcode }}</p>
									<p>Visit <a href="http://www.fb.org/about/join" target="_blank">your local Farm Bureau site</a> to find the Farm Bureau insurance provider in your state.</p>
								</div>
							</fragment>

							<fragment v-if="tab === 'name'">
								<div class="bg-quaternary tall-box name-box" v-if="specification.Name === null  || specification.StateCode === null" id="name-tab">
									<h2>Enter state and agent name above</h2>
								</div>
								<div class="bg-quaternary" v-else>
									<h2>Sorry, we couldn’t find anyone matching your specifications</h2>
									<p>
										<span v-if="specification.Name !== null"><b>Name:</b> {{ specification.Name }}<br /></span>
										<span v-if="specification.StateCode !== null"><b>State:</b> {{ specification.StateCode }}</span>
									</p>
								</div>
							</fragment>

							<p id="js-full-agent" v-if="this.tab === 'location' ">View our full <a href="/find-an-agent/agent-directory">Agent Directory</a></p>
						</div>
					</div>
                        <agent-map v-if="pagedItems && pagedItems.length > 0" aria-label="map" role="region"></agent-map>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import 'url-search-params-polyfill';
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/pagination';
	import AgentMap from '../components/map';
	import AgentCard from '../components/agent-card';
	import SelectControl from '../../common/components/ui/select-control';
	import TextboxControl from '../../common/components/ui/textbox-control';
	import AgentSearchFilter from '../filters/agent-search-filter';
	import getState from '../services/get-state.service';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource'],
		data: function () {
			return {
				filters: null,
				tab: 'location',
				filterOpen: false,
				agentType: '',
				agentTypeDisplayName: '',
				maxMiles: 25,
			}
		},
		computed: {
			...mapState({
				loading: state => state.listing.loading,
				listing: state => state.listing.listing,
				specification: state => state.listing.specification,
				currentPage: state => state.listing.currentPage,
			}),
			pagedItems() {
				const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
				let labelIndex = 0;

				let listingOffices = JSON.parse(JSON.stringify(this.listing.slice((this.currentPage * 10) - 10, (this.currentPage * 10))));

				if (listingOffices && listingOffices.length > 0) {
					listingOffices.forEach((agent) => {
						agent.Offices.forEach((office) => {
							office.label = labels[labelIndex++ % labels.length];
						});
					});
				}

				return listingOffices;
			},
		},
		components: {
			pagination: Pagination,
			'agent-map': AgentMap,
			'agent-card': AgentCard,
			'textbox-control': TextboxControl,
			'select-control': SelectControl
		},
		mounted: function () {
			let _this = this;

			if (this.result && this.result.Specification) {
				if (this.result.Specification.Zipcode !== null) {
					AgentSearchFilter.StateCode.defaultValue = getState(this.result.Specification.Zipcode);
				}
				if (this.result.Specification.AgentType !== null) {
					this.agentType = this.result.Specification.AgentType;
				}
				if (this.result.Specification.MaxMiles !== null) {
					this.maxMiles = this.result.Specification.MaxMiles;
				}
			}

			if (this.result.Specification.StateCode !== null || this.result.Specification.Name !== null) {
				this.tab = 'name';
			}

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			this.filters = AgentSearchFilter;

			// after filter comes back, scroll to the top
			let scroll = new SmoothScroll();
			let options = {
				header: '[data-scroll-header]',
                speed: 1000,
				offset: 96
			};

			// after any api calls, scroll to the top of the list
			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					let anchor = document.querySelector('#' + _this.filterid);
					let header = document.getElementsByClassName('header')[0];

					scroll.animateScroll(anchor, null, options);

					setTimeout(() => {
						scroll.cancelScroll();
					}, 2000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state, tab = this.tab) => {
				if (mutation.type === 'listing/updateSpecification') {
					if(tab === 'location'){
						if(!isNaN(state.listing.specification.Zipcode)){
							this.setFilter();
						}
					}else{
						this.setFilter();
					}
				}
				if (mutation.type === 'listing/updateSubFilters') {
					if(tab === 'location'){
						if(!isNaN(state.listing.specification.Zipcode)){
							this.setFilter();
						}
					}else{
						this.setFilter();
					}
					this.filterOpen = false;
				}
			});

			this.populateAgentTypeDisplayName();
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { updateSubFilters: 'updateSubFilters' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
			...mapMutations('listing', { clearListing: 'clearListing' }),
			applyFilters() {
				this.updateSubFilters({ maxMiles: this.maxMiles, agentType: this.agentType });
				this.populateAgentTypeDisplayName();
			},
			setTab(tabName) {
				this.tab = tabName;
				// clear listing in store
				this.clearListing();
			},
			tabSelect(e) {
				switch(e.key) {
					case 'ArrowLeft':
					case 'ArrowRight':
						if(this.tab === 'location') this.setTab('name');
						else this.setTab('location');
					break;
				}
				$(this.tab).focus();
			},
			toggleFilter() {
				this.filterOpen = !this.filterOpen;
				if (this.filterOpen) {
					$('button.filter-btn').attr('aria-expanded', true);
				} else {
					$('button.filter-btn').attr('aria-expanded', false);
				}
			},
			clearSelect(select) {
				$('#' + select).blur();
			},
			populateAgentTypeDisplayName() {
				// Populate Agent Type Display Name
				let agentTypeObject = this.filters.AgentType.subgroup.filter((x)=>{ return x.Value == this.agentType })
				if(agentTypeObject.length > 0){
					this.agentTypeDisplayName = agentTypeObject[0].Name;
				}
			},
        },
    }
</script>